import type { DocCollection } from '@blocksuite/store';
import { createNewDoc, type LoadedBlockSuiteDoc } from '@toeverything/infra';
import { useMemo } from 'react';

export function useDocCollectionHelper(docCollection: DocCollection) {
  return useMemo(
    () => ({
      createDoc: (pageId?: string): LoadedBlockSuiteDoc => {
        return createNewDoc(docCollection, pageId);
      },
    }),
    [docCollection]
  );
}
